'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ingredientForm = require('./ingredient-form.html');

var _ingredientForm2 = _interopRequireDefault(_ingredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _ingredientForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    companyId: '<',
    ingredient: '<',
    ingredients: '<',
    submitTitle: '@',
    unitsDisplay: '<',
    weightUnits: '<',
    ingredientChanged: '&',
    index: '<',
    showAdditionalButton: '<',
    disallowActiveIngredients: '<'
  },
  controller: function () {
    function IngredientFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, IngredientFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(IngredientFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        if (this.ingredient) {
          this.selectedIngredient = this.ingredient;
        } else if (this.disallowActiveIngredients) {
          this.ingredient = {
            Active: false
          };
        }

        this.ingredients = this.ingredients || [];
      }
    }, {
      key: 'ingredientTypeChanged',
      value: function ingredientTypeChanged(isActive) {
        this.validateDuplicates();

        if (!isActive) {
          this.ingredient = _extends({}, this.ingredient, {
            Weight: null,
            WeightUnit: null
          });
        }
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit(shouldClose) {
        var ingredient = _extends({}, this.selectedIngredient, this.ingredient);

        this.ingredients.push(ingredient);

        this.ingredientChanged(this.EventEmitter({
          ingredient: ingredient,
          shouldClose: shouldClose,
          index: this.index
        }));

        this.ingredient = {};

        this.selectedIngredient = null;
        this.ingredientSearchText = '';
      }
    }, {
      key: 'selectedSearchIngredientChanged',
      value: function selectedSearchIngredientChanged($event) {
        this.selectedIngredient = $event.selectedIngredient;
        if (this.disallowActiveIngredients) {
          this.ingredient = _extends({}, this.selectedIngredient, {
            Active: false
          });
        }
        this.validateDuplicates();
      }
    }, {
      key: 'validateDuplicates',
      value: function validateDuplicates() {
        var _this = this;

        var isValid = true;

        if (this.selectedIngredient) {
          // Business rule - ensure no duplicates
          var index = this.ingredients.findIndex(function (i) {
            return i.UserIngredientId === _this.selectedIngredient.UserIngredientId;
          });

          if (index !== -1 && this.index !== index) {
            isValid = false;
          }
        }

        this.ingredientForm.$setValidity('duplicate', isValid);
      }
    }]);

    return IngredientFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/ingredient-form/ingredient-form.component.js